import React from 'react';
import { motion } from 'framer-motion';

const Scene = ({ children, scene }) => {
  // Check if we're in Phase I
  const isPhaseI = scene.phase === 'I';
  // Check if this is a room (Feel, Weigh, Translate, Close) or path choice - no scene indicators
  const isRoom = scene.isFeelRoom || scene.isWeighRoom || scene.isTranslateRoom || scene.isClosingRitual || scene.isPathChoice;

  return (
    <motion.div
      className="vaulten-scene"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ 
        duration: 2.5, 
        ease: [0.25, 0.1, 0.25, 1] 
      }}
    >
      {/* Scene number indicator - hidden for rooms and path choice */}
      {!isRoom && scene.subtitle && (
        <>
          <motion.div 
            className="absolute top-8 left-8 vaulten-title hidden sm:block"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5, duration: 2 }}
          >
            <span className="opacity-30">Scene {scene.id}</span>
            <span className="mx-3 opacity-15">—</span>
            <span className="opacity-50">{scene.subtitle}</span>
            {isPhaseI && (
              <span 
                className="ml-4 opacity-20 text-[9px] tracking-[0.3em]"
                style={{ color: 'hsl(38, 20%, 50%)' }}
              >
                I
              </span>
            )}
          </motion.div>

          {/* Mobile scene indicator - simpler */}
          <motion.div 
            className="absolute top-20 left-1/2 -translate-x-1/2 vaulten-title sm:hidden text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5, duration: 2 }}
          >
            <span className="opacity-40 text-[10px]">{scene.subtitle}</span>
          </motion.div>
        </>
      )}

      {/* Main content */}
      <div className="max-w-2xl mx-auto px-6 pt-8 sm:pt-0">
        {children}
      </div>
    </motion.div>
  );
};

export default Scene;
